<div class="next-call-options-container">
  <span class="next-call-label"><strong>Next Call:</strong> {{ scheduledCallDate }}</span>
</div>
<app-calendar (dateFilterChangeEvent)="handleDateFilterChangeEvent($event)"> </app-calendar>
